const API_URL = process.env.REACT_APP_BACKEND_API_URL;
console.log("this is api url", API_URL, "this is api url", process.env);
export default API_URL;